module.exports = __webpack_public_path__ + "img/album07_36.958f1167.jpg";